import {
  listStudyQueriesStudiesStudyIdQueriesGet,
  ListStudyQueriesStudiesStudyIdQueriesGetResponse,
  HTTPValidationError,
} from '@common/config/api/client'
import { UseStudyQueriesListOptions, QueryListParams } from '../types/types'
import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import studyQueryKeys from './queryKeyFactory'

export function useStudyQueriesList(
  params: QueryListParams,
  options: UseStudyQueriesListOptions = {},
): UseQueryResult<ListStudyQueriesStudiesStudyIdQueriesGetResponse, AxiosError<HTTPValidationError>> {
  const { study_id, ...queryParams } = params

  return useQuery({
    queryKey: studyQueryKeys.list(params),
    queryFn: async () => {
      const response = await listStudyQueriesStudiesStudyIdQueriesGet({
        path: { study_id: study_id },
        query: queryParams,
        throwOnError: true,
      })
      return response.data
    },
    enabled: options.enabled ?? true,
  })
}
